export const HEADSHOT_DESCRIPTION =
  "Automatically verify that a contractor's photo is a professional headshot suitable for business use. Our AI checks for a single, clear face and rejects images that are blurry, unprofessional, or contain obstructions.";

export const HEADSHOT_EXAMPLE_USE_CASES =
  "ID badge photos, company directories, ensuring a professional profile picture.";

export const HEADSHOT_COST = "$1.99 per verification";

export const HEADSHOT_INSTRUCTIONS = `### **Requirement guide for headshot** 
Upload a digital copy of your headshot. Make sure all information is legible and matches the verification requirements below.

**Upload headshot:**

- **Prepare your file**
  - Have a clear digital copy ready.
  - Check that all text is legible.
  - Review the verification details below to confirm your headshot / photo meets the requirements.

- **Upload your file**
  - Upload your file on the next page.

- **Accepted formats:**
  - Document (pdf)
  - Image (jpeg, png, webp, heic, heif)
  - Max 100MBs per file
`;

export const HEADSHOT = {
  instructions: HEADSHOT_INSTRUCTIONS,
  description: HEADSHOT_DESCRIPTION,
  exampleUseCases: HEADSHOT_EXAMPLE_USE_CASES,
  cost: HEADSHOT_COST
};
